import React from 'react'
import { View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

/**
 * Paints the status-bar strip (the top safe-area inset) in the colour of the
 * header below it, so the device bar reads as part of the app's top bar.
 * Android draws edge-to-edge with a transparent status bar, so without this the
 * strip shows the screen canvas above a paper-coloured header.
 *
 * Use it with a `SafeAreaView` that omits the `top` edge: the fill takes the
 * exact height that padding would have, so the layout below does not move.
 * Negative side margins carry the strip across the left/right insets the
 * SafeAreaView still pads, so it spans the full width in landscape too.
 * Zero height on web and on devices without a top inset.
 */
export const SAFE_AREA_EDGES_BELOW_FILL = ['left', 'right', 'bottom'] as const

export function TopInsetFill({ className = 'bg-paper', color }: { className?: string; color?: string }) {
  const { top, left, right } = useSafeAreaInsets()
  return <View testID="top-inset-fill" pointerEvents="none" className={className}
    style={[{ height: top, marginLeft: -left, marginRight: -right }, color ? { backgroundColor: color } : null]} />
}
